// Record visible visits and real interactions, never timers or API polling.
export function observeActivity(send, doc = document, now = Date.now) {
  let lastSuccess = -Infinity;
  let lastAttempt = -Infinity;
  let pending = false;
  let stopped = false;
  const visit = async () => {
    const stamp = now();
    if (stopped || doc.visibilityState !== "visible" || pending ||
        stamp - lastSuccess < 5 * 60 * 1000 || stamp - lastAttempt < 10000) return;
    lastAttempt = stamp;
    pending = true;
    try {
      await send();
      lastSuccess = stamp;
    } catch {
      // Retrying is driven by another visit/interaction, not background traffic.
    } finally {
      pending = false;
    }
  };
  const interact = event => { if (event.isTrusted) visit(); };
  const events = ["pointerdown", "keydown", "wheel", "touchstart"];
  events.forEach(name => doc.addEventListener(name, interact, { passive: true }));
  doc.addEventListener("visibilitychange", visit);
  visit();
  return () => {
    stopped = true;
    events.forEach(name => doc.removeEventListener(name, interact));
    doc.removeEventListener("visibilitychange", visit);
  };
}
